import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/logo/logo.png'
import _imports_1 from '../../../public/img/nav/title_1.png'
import _imports_2 from '../../../public/img/nav/title_2.png'
import _imports_3 from '../../../public/img/nav/title_3.png'
import _imports_4 from '../../../public/img/nav/title_4.png'
import _imports_5 from '../../../public/img/nav/title_5.png'
import _imports_6 from '../../../public/img/nav/title_6.png'
import _imports_7 from '../../../public/img/nav/title_7.png'
import _imports_8 from '../../../public/img/solution/soulition1.png'
import _imports_9 from '../../../public/img/solution/soulition2.png'
import _imports_10 from '../../../public/img/solution/soulition3.png'


const _withScopeId = n => (_pushScopeId("data-v-7d80cf62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: "分蛋科技"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = ["onClick", "onMouseover", "onMouseout"]
const _hoisted_6 = { class: "cn-label" }
const _hoisted_7 = { class: "en-label" }
const _hoisted_8 = { class: "popup-wrapper" }
const _hoisted_9 = ["id", "onMouseleave"]
const _hoisted_10 = { class: "pop-content" }
const _hoisted_11 = { style: {"width":"98%"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"height":"40px"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "tr-top" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px","width":"14%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_1
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字婚嫁"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Marriage")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"140px","width":"14%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_2
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字业财税"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Fnance and taxation")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px","width":"14%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_3
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字零售"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Retail")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"160px","width":"15%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_4
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字办公"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Official")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"150px","width":"15%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_5
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字权益"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Rights and interests")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"140px","width":"14%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_6
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "云产品"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Cloud")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"130px","width":"14%"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","gap":"5px"} }, [
        /*#__PURE__*/_createElementVNode("div", null, [
          /*#__PURE__*/_createElementVNode("img", {
            style: {"width":"20px","height":"20px"},
            class: "logo-img",
            src: _imports_7
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"column","align-items":"flex-start"} }, [
          /*#__PURE__*/_createElementVNode("div", { style: {"color":"#323232"} }, "数字服务"),
          /*#__PURE__*/_createElementVNode("div", { style: {"transform":"scale(0.7)","transform-origin":"left center","color":"#A3A4A7"} }, "Service")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_13 = { style: {"position":"relative","top":"10px"} }
const _hoisted_14 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_15 = { class: "bodytd" }
const _hoisted_16 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_17 = { class: "bodytd" }
const _hoisted_18 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_19 = { class: "bodytd" }
const _hoisted_20 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_21 = { class: "bodytd" }
const _hoisted_22 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_23 = { class: "bodytd" }
const _hoisted_24 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_25 = { class: "bodytd" }
const _hoisted_26 = { style: {"position":"relative","left":"25px","color":"#A3A4A7"} }
const _hoisted_27 = { class: "bodytd" }
const _hoisted_28 = ["id", "onMouseleave"]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"pop-content\" data-v-7d80cf62><div style=\"display:flex;justify-content:space-between;margin-top:15px;\" data-v-7d80cf62><div class=\"pop-solution\" data-v-7d80cf62><img class=\"pop-solution-img\" src=\"" + _imports_8 + "\" alt=\"\" style=\"max-width:95%;height:auto;border-radius:5px;\" data-v-7d80cf62><div style=\"color:#000;margin-top:15px;font-size:1.1rem;\" data-v-7d80cf62>智慧婚嫁</div></div><div class=\"pop-solution\" data-v-7d80cf62><img class=\"pop-solution-img\" src=\"" + _imports_9 + "\" alt=\"\" style=\"max-width:95%;height:auto;border-radius:5px;\" data-v-7d80cf62><div style=\"color:#000;margin-top:15px;font-size:1.1rem;\" data-v-7d80cf62>智慧教育</div></div><div class=\"pop-solution\" data-v-7d80cf62><img class=\"pop-solution-img\" src=\"" + _imports_10 + "\" alt=\"\" style=\"max-width:95%;height:auto;border-radius:5px;\" data-v-7d80cf62><div style=\"color:#000;margin-top:15px;font-size:1.1rem;\" data-v-7d80cf62>智慧健康</div></div></div></div>", 1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chooseNavLogo(0)))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: _normalizeClass(["ppp", [
        _ctx.navIndex === index ? 'active' : '',
        item.value === 'activity' ? 'relative' : '',
        { 'hide-background': _ctx.hideBackground }
      ]]),
          key: index,
          onClick: ($event: any) => (_ctx.chooseNav(index)),
          onMouseover: ($event: any) => (_ctx.showPopup(index)),
          onMouseout: ($event: any) => (_ctx.hidePopup(index))
        }, [
          _createVNode(_component_router_link, {
            to: { path: item.path},
            style: {"display":"flex","flex-direction":"column","align-items":"center"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.enLabel), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("span", _hoisted_8, [
            _withDirectives(_createElementVNode("div", {
              id: 'popup-' + index,
              class: "popup",
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("tbody", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "tr-bom",
                        key: index,
                        style: {"line-height":"2.2rem"}
                      }, [
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.col1), 1)
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.col2), 1)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.col3), 1)
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(item.col4), 1)
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.col5), 1)
                        ]),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.col6), 1)
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(item.col7), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 40, _hoisted_9), [
              [_vShow, _ctx.popupVisible[index]]
            ]),
            _withDirectives(_createElementVNode("div", {
              style: {"height":"20vw"},
              id: 'popup2-' + index,
              class: "popup",
              onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, _hoisted_30, 40, _hoisted_28), [
              [_vShow, _ctx.popupVisible[index]]
            ])
          ])
        ], 42, _hoisted_5))
      }), 128))
    ])
  ]))
}